/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment-timezone';

import Text from '../../../../shared/components/Text/Text';

const DropHereDiv = styled('div')`
  width: 100%;
  color: white;
  display: flex;
  align-items: center;
  position: relative;
`;

const DropHereText = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  font-family: 'Nunito Sans';
  display: flex;
  text-align: center;
`;

const DropHereSection = ({
  id,
}) => {
  const dragSource = useSelector((state) => state.calendar.data.dragSource);
  const onBeforeCapture = useSelector((state) => state.calendar.data.onBeforeCapture);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
  const programType = useSelector((state) => state.calendar.data.programType);
  const calendarItems = programType === 'free-form-program'
    ? useSelector((state) => state.calendar.data.nonDateBasedProgramItems[
      selectedProgramDayNumber
    ]?.exercises || []) : useSelector((state) => state.calendar.data.calendarItems[formattedDate]?.exercises || []);
  const isDragging = useSelector((state) => state.calendar.data.isDragging);

  /** Check if component should be shown */
  const shouldShow = onBeforeCapture && !calendarItems?.length && dragSource !== id;
  /** Check if dragging from templates sidebar by looking at dragSource directly */
  const isFromTemplates = dragSource === 'templates-sidebar';

  if (!shouldShow) return null;

  return (
    <DropHereDiv calendarItemLength={calendarItems.length}>
      <DropHereText>
        <Text color='#5F8BDC' fontWeight={700} fontSize='16px'>
          {isFromTemplates
            ? 'Drag & Drop Program Here to Load Program'
            : 'Drag & Drop Exercise Here'}
        </Text>
      </DropHereText>
    </DropHereDiv>
  );
};

export default DropHereSection;
